module.exports = `${require.publicPath}download-code.47764eea.png`;